export default __webpack_public_path__ + "static/chip-8b6ba3a80f5c892749fa3887a9cca6ea.svg";